import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  if (request && new URL(request.url).pathname.startsWith("/lovable/")) {
    return next();
  }
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

const LEGACY_HOSTS = new Set([
  "sepremiumcabs.com.au",
  "www.sepremiumcabs.com.au",
]);
const CANONICAL_ORIGIN = "https://sepremiumcabs.com";

const canonicalHostMiddleware = createMiddleware().server(async ({ next, request }) => {
  if (request) {
    const url = new URL(request.url);
    const host = (request.headers.get("host") ?? url.host).toLowerCase().split(":")[0];
    if (LEGACY_HOSTS.has(host)) {
      return new Response(null, {
        status: 301,
        headers: {
          location: `${CANONICAL_ORIGIN}${url.pathname}${url.search}`,
          "cache-control": "public, max-age=3600",
        },
      });
    }
  }
  return next();
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [canonicalHostMiddleware, errorMiddleware],
}));
